import { enhanceGame, enhanceLocation } from "../lib/utils"
import { map, omit, chain } from "underscore"

export default (state, action) => {
  switch (action.type) {
    case "UPDATE_NEW_GAME_DETAILS":
      const updatedNewGame = Object.assign({}, state.newGame, action.values)
      return {
        ...state,
        newGame: updatedNewGame
      }
    case "SAVE_TOKEN": {
      return {
        ...state,
        token: action.token
      }
    }
    case "RECEIVE_APP_DETAILS": {
      const locations = chain(action.locations)
        .sortBy("ssc_name")
        .sortBy("state")
        .map(enhanceLocation)
        .value()
      return {
        ...state,
        gameLocations: locations,
        gameProducts: action.products,
        userCountryDetected: action.userCountryDetected
      }
    }
    case "RECEIVE_USER_GAME_DETAILS": {
      const games = map(action.details, (game) => (
        enhanceGame(game)
      ))
      return {
        ...state,
        games: games
      }
    }
    case "RECEIVE_TEAM_MEMBERS": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.id !== action.team.game_id) return game
          return {
            ...game,
            team: action.team
          }
        })
      }
    }
    case "RECEIVE_START_GAME": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            ...action.details
          }
        })
      }
    }
    case "RECEIVE_INVITE_TEAM_MEMBERS": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.id !== action.team.game_id) return game
          return {
            ...game,
            team: {
              ...action.team,
              inviteErrors: action.errors.length ? action.errors : null
            }
          }
        })
      }
    }
    case "RECEIVE_UPDATED_TEAM": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.id !== action.team.game_id) return game
          return {
            ...game,
            team: {
              ...action.team,
            }
          }
        })
      }
    }
    case "RECEIVE_UPDATE_GAME": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            ...action.updatedGame,
            team: {
              ...game.team,
              ...action.updatedTeam
            }
          }
        })
      }
    }
    case "CLEAR_INVITE_ERRORS": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.id !== action.gameId) return game
          return {
            ...game,
            team: {
              ...game.team,
              inviteErrors: null
            }
          }
        })
      }
    }
    case "RECEIVE_LOST_GAME_DETAILS": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            lostDetails: action.details
          }
        })
      }
    }
    case "CLEAR_LOST_GAME_DETAILS": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            lostDetails: null
          }
        })
      }
    }
    case "RECEIVE_ACCEPT_TEAM_INVITE": {
      return {
        ...state,
        newInvite: {
          status: action.status,
          message: action.message
        }
      }
    }
    case "CLEAR_ACCEPT_TEAM_INVITE_STATUS": {
      return {
        ...state,
        newInvite: null
      }
    }
    case "RECEIVE_BROKEN_PHONE_HELP": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            brokenPhone: {
              cabinetId: action.cabinetId,
              message: action.message,
              urls: action.urls,
              verification: action.verification
            }
          }
        })
      }
    }
    case "CLEAR_BROKEN_PHONE_HELP": {
      return {
        ...state,
        games: state.games.map(game => {
          if (game.uuid !== action.gameUuid) return game
          return {
            ...game,
            brokenPhone: null
          }
        })
      }
    }
    case "RECEIVE_PAYMENT_INTENT": {
      return {
        ...state,
        paymentToken: action.clientSecret,
        paymentAmount: action.amount,
        paymentPromoMsg: action.promoMessage,
        paymentIdempotencyKey: action.idempotencyKey
      }
    }
    case "CLEAR_PAYMENT_INTENT": {
      return {
        ...state,
        paymentToken: null,
        paymentAmount: null,
        paymentPromoMsg: null
      }
    }
    case "SET_SETUP_ERROR_TEXT": {
      return {
        ...state,
        setupErrorText: action.text
      }
    }
    case "CLEAR_SETUP_ERROR_TEXT": {
      return {
        ...omit(state, "setupErrorText"),
      }
    }
    case "SET_ACTIVE_STEP": {
      return {
        ...state,
        activeStep: action.step
      }
    }
    case "CLEAR_ACTIVE_STEP": {
      return {
        ...omit(state, "activeStep"),
      }
    }
    case "ADD_ERROR_MESSAGE": {
      return {
        ...state,
        errorMessage: action.errorMessage
      }
    }
    case "DELETE_ERROR_MESSAGE": {
      return {
        ...state,
        errorMessage: null
      }
    }
    // handle errors
    case "": {
      return {
        ...state,
        errorMessage: action.errorMessage
      }
    }
    default:
      return state
  }
}
